module.exports = __webpack_public_path__ + "img/dc52cbd.png";